import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoanRepaymentTemplate } from 'app/model/loanrepaymenttemplate';
import { AccountSearchSummary } from 'app/model/accountsearchsummary';
import { LoanScheduleResponse } from 'app/model/loanschedule';
import { Router, ActivatedRoute } from '@angular/router';
import { LoanTransactionsService } from '../loan-transactions.service';
import { SelectedCurrencyOptions } from 'app/model/currencyoptions';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { SettingsService } from 'app/settings/settings.service';
import { DatePipe } from '@angular/common';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { Subscription } from 'rxjs';
import { CheckDetails } from 'app/model/checkdetails';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'mifosx-loan-checkreversal',
  templateUrl: './loan-checkreversal.component.html',
  styleUrls: ['./loan-checkreversal.component.scss']
})
export class LoanCheckReversalComponent implements OnInit {
  /** Loan Id */
  loanId: string;

  checkId: string;
  rejectCode: string;
  rejectDescription: string;

  /** Payment Type Options */
  paymentTypes: any;

  checkReversalLoanForm: FormGroup;

  /** Show payment details */
  showPaymentDetails = false;

  /** Show check details */
  showCheckDetailsView: Boolean = false;
  addCheckDetailsFlag: Boolean = false;

  /** Check Details */
  checkDetailsTable = new MatTableDataSource<CheckDetails>();
  checkDetails: Array<CheckDetails> = [];
  checkDetail: CheckDetails = {
    id: 0,
    checkAccountNumber: '',
    checkNumber: '',
    checkSecurityNumber: '',
    checkAmount: '',
    checkAmountToDeposit: '',
    targetName: '',
    countryCode: '',
    currencyCode: null,
    bankCode: '',
    locale: ''
  };
  checkForm: FormGroup;



  /** A summary of loan a ccount from search */
  loanAccountSummary: AccountSearchSummary;

  /** Template to populate loan repayment form */
  loanRepaymentTemplate: LoanRepaymentTemplate;

  /** Flag to control if loan repayment view should be shown */
  showLoanRepaymentView: boolean = false;

  /** Flag to show loan summary view */
  showLoanSummaryView: boolean = false;

  /**System supported currencies */
  currencyOptions: SelectedCurrencyOptions;
  selectedTeller: any;
  isDisabled: boolean = false;
  nextRepaymentDate: string;
  expectedAmount: string;
  expectedAmountValue: number;
  tellerSub: Subscription;
  pageTitle: string = 'Pago de préstamos';
  isQuoteGeneration: boolean = false;


  existentChecks: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loanService: LoanTransactionsService,
    private receiptService: ReceiptServiceService,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper,
    private settingsService: SettingsService,
    private datePipe: DatePipe,
    private tellerGlobalService: TellerGlobalServiceService) { }

  ngOnInit(): void {
    this.createcheckReversalLoanForm();

    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
    this.route.data.subscribe(({ supportedCurrencies,loanTemplateData }) => {
      this.currencyOptions = supportedCurrencies;
      this.loanRepaymentTemplate = loanTemplateData;

      if(loanTemplateData){
        this.setDependantFieldsForLoanTemplate(loanTemplateData);
      }
    })

    this.route.paramMap.subscribe(params => {
      this.loanId = params.get('id');
    });

    this.route.pathFromRoot[2].url.subscribe(url => {
      if (url[0].path === 'cotizaciones') {
        this.isQuoteGeneration = true;
        this.pageTitle = 'Generación de cotización';
      }
    });

  }

  ngOnDestroy() {
    this.tellerSub.unsubscribe();
  }
  /**
   * Creates the create close form.
   */
  createcheckReversalLoanForm() {
    this.checkReversalLoanForm = this.formBuilder.group({
      'transactionDate': [new Date(), Validators.required],
      'rejectCode': ['', Validators.required],
      'rejectDescription': ['', Validators.required],
      'checkId': ['', Validators.required],
    });
  }

  updateAccountDetail(event: Array<AccountSearchSummary>) {

    if (event.length > 0) {
      this.loanAccountSummary = event.pop();
      this.showLoanSummaryView = true;
      this.loanId = this.loanAccountSummary.entityId.toString();

      this.loanService.getLoanActionTemplate<LoanRepaymentTemplate>(<string><unknown>this.loanAccountSummary.entityId)
        .subscribe(res => {
          this.loanRepaymentTemplate = res;

          this.setDependantFieldsForLoanTemplate(res)
        });


        console.clear();
        this.loanService.getLoanRejectCheckTemplate(<string><unknown>this.loanId)
        .subscribe(res => {
          this.existentChecks = res;
          console.log(this.existentChecks);
        }); 

    } else {
      this.showLoanRepaymentView = false;
    }
  }

  setDependantFieldsForLoanTemplate(res: any) {

    this.showLoanRepaymentView = true;
    this.expectedAmountValue = res.amount;
    this.nextRepaymentDate = this.datePipe.transform(this.loanRepaymentTemplate.date, this.settingsService.dateFormat)
    this.expectedAmount = `${this.loanRepaymentTemplate.amount} (${this.loanRepaymentTemplate.currency.code})`;
    this.checkReversalLoanForm.controls['currencyCode'].setValue(this.loanRepaymentTemplate.currency.code);
  }

  checkForEnableCheckOption(value: any) {
    this.showCheckDetailsView = (value === 2 || value === 3);
  }


  /** Submits the repayment form */
  submit() {
    this.isDisabled = true;

    var foreclosureDateCopy = this.datePipe.transform(this.checkReversalLoanForm.get('transactionDate').value, "MM/dd/yyyy");

    const prevTransactionDate: Date = new Date(foreclosureDateCopy);
    // TODO: Update once language and date settings are setup
    const dateFormat = this.settingsService.dateFormat;
    this.checkReversalLoanForm.patchValue({
      transactionDate: this.datePipe.transform(foreclosureDateCopy, "dd/MM/yyyy")
    });

    const repaymentLoanData = this.checkReversalLoanForm.value;
    repaymentLoanData.locale = this.settingsService.language.code;
    repaymentLoanData.dateFormat = "dd/MM/yyyy";

    this.loanService.submitLoanRejectCheckT(<string><unknown>this.loanId, <string><unknown>repaymentLoanData.checkId, repaymentLoanData)
      .subscribe((res: any) => {
        this.router.navigate([''], { relativeTo: this.route,state: { message: res } });
      }, error => {
        console.log("Error Pago")
        console.log(error);
        this.isDisabled = false;
      },);

  }

}
